import api from './api';

/**
 * The feature flags this environment has on, as the server reports them.
 *
 * Read once during bootstrap, before anyone signs in, so the app knows which
 * unfinished features to leave out. The server gates the matching routes
 * regardless of what the bundle renders; this only shapes what is shown.
 *
 * Only enabled flags are listed. Anything absent is off, which is why the
 * default below is an empty list rather than a guess.
 */
export const DEFAULT_FEATURES = [];

/**
 * The flags this client knows how to render. Mirrors FEATURE_FLAGS in
 * server/src/config/index.js, and exists to catch drift between the two:
 * a name that only one side knows would otherwise read as off with nothing
 * logged, which is the silent typo the server's own guard refuses to allow.
 */
export const KNOWN_FEATURES = [
    'coordinatorReview',
    'studentApplication',
    'hiring',
    'contractAcceptance',
    'surveys',
    'training',
    'assistants',
];

// The page renders without waiting for this, so a stall no longer holds
// anything up — but it still needs a ceiling. A refused connection rejects
// immediately; a server that accepts and then stalls (a task mid rolling
// update, a draining load balancer) would otherwise leave the request hanging
// and every flag off with no resolution either way. On a timeout every flag
// stays off, which costs a hidden feature, and a reload retries it.
const FEATURES_TIMEOUT_MS = 3000;

export const featureService = {
    async getFeatures() {
        const response = await api.get('/features', {
            timeout: FEATURES_TIMEOUT_MS,
        });
        return response.data;
    },
};

export default featureService;
